<template>
  <b-container fluid>
    <h1>Matchfights Setup</h1>
    <h2>Fights</h2>
    <div class="mb-4">
      <b-table
        :fields="fields"
        head-variant="dark"
        :items="fights"
        small
      >
        <template v-slot:cell(time)="data">
          {{ data.item.rounds }} x {{ formattedTime(data.item.duration) }}
        </template>
        <template v-slot:cell(athleteRed)="data">
          <div>{{ data.item.athleteRed.name }}</div>
          <div class="text-muted small">{{ data.item.athleteRed.team }}</div>
        </template>
        <template v-slot:cell(athleteBlue)="data">
          <div>{{ data.item.athleteBlue.name }}</div>
          <div class="text-muted small">{{ data.item.athleteBlue.team }}</div>
        </template>
        <template v-slot:cell(weightClass)="data">
          {{ weightClass(data.item.weightClass).stringDe }}
        </template>
        <template v-slot:cell(extraTime)="data">{{ formattedTime(data.item.extraTime) }}</template>
        <template v-slot:cell(action)="data">
          <b-button
            size="sm"
            variant="primary"
            @click="setModal(data.item.id)"
          >Edit</b-button>
          <MatchFightModal
            :fight="data.item"
            :show="showModal(data.item.id)"
            @close="currentModal = null"
          />
        </template>
      </b-table>
    </div>
    <div v-if="athletes.length">
      <h2>Unassigned athletes</h2>
      <b-table
        head-variant="dark"
        :items="athletes"
        small
      >
        <template v-slot:cell(weightClass)="data">
          {{ weightClass(data.item.weightClass).stringDe }}
        </template>
      </b-table>
      <b-button @click="showCreateModal = true" variant="success">Add fight</b-button>
    </div>
    <MatchFightCreateModal @close="showCreateModal = false" :show="showCreateModal"/>
    <div class="d-flex justify-content-between mt-5">
      <b-button @click="$emit('back')">Back to Tournament Setup</b-button>
      <b-button :disabled="athletes.length > 0" variant="primary" @click="$emit('next')"
      >Go to Schedule Preview</b-button>
    </div>
  </b-container>
</template>

<script>
import MatchFightModal from '@/components/Setup/MatchFightModal.vue';
import MatchFightCreateModal from '@/components/Setup/MatchFightCreateModal.vue';

export default {
  name: 'SetupMatchFights',
  components: { MatchFightCreateModal, MatchFightModal },
  data() {
    return {
      currentModal: null,
      fields: ['weightClass', 'type', 'athleteRed', 'athleteBlue', 'time', 'extraTime', 'action'],
      durationSelect: [
        { value: 120, text: '2:00' },
        { value: 180, text: '3:00' },
        { value: 300, text: '5:00' },
      ],
      roundsSelect: [1, 2, 3, 4, 5],
      typeSelect: ['amateur', 'pro'],
      showCreateModal: false,
      weightClasses: [
        { value: 155, text: 'Leichtgewicht 70.1 kg' },
        { value: 170, text: 'Weltergewicht 77.1 kg' },
        { value: 185, text: 'Mittelgewicht 83.9 kg' },
        { value: 205, text: 'Halbschwergewicht 93.0 kg' },
        { value: 265, text: 'Schwergewicht 120.1 kg' },
      ],
    };
  },
  methods: {
    decreaseExtraTime() {
      this.fight.extraTime = parseInt(this.fight.extraTime, 10) - 60;
    },
    increaseExtraTime() {
      this.fight.extraTime = parseInt(this.fight.extraTime, 10) + 60;
    },
    getFight(id) {
      return this.$store.state.setup.matchFights.fights.find((fight) => fight.id === id);
    },
    formattedTime(value) {
      const minutes = Math.floor(value / 60);
      const seconds = value % 60;
      return `${minutes}:${String(seconds).padStart(2, '0')}`;
    },
    setModal(id) {
      this.currentModal = id;
    },
    showModal(id) {
      return this.currentModal === id;
    },
    weightClass(weight) {
      return this.$weightClasses().find((wc) => wc.weight === weight);
    },
  },
  computed: {
    athletes() {
      return this.$store.state.setup.matchFights.athletes;
    },
    fights() {
      return this.$store.state.setup.matchFights.fights;
    },
  },
  created() {
    if (this.create) {
      this.fight = {
        rounds: 3,
        duration: 300,
        extraTime: 300,
        rules: 'pro',
      };
    }
  },
};
</script>

<style scoped>

</style>
